import { useAppSelector } from "../../../redux/hooks";
import { useFetch } from "../../../hooks/api";
import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPContextualProducts = (searchFilter = null) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const asinRegex = /\b[A-Z0-9]{10}\b/g;
  const asinsInSearchFilter = searchFilter.match(asinRegex);
  const params = {
    marketplace: marketPlace,
    dsp_seller_info_id: dspAdvertiser?.id,
  };

  if (asinsInSearchFilter) {
    params.asin = `${asinsInSearchFilter.map((asin) => "inc_" + asin)},`;
  } else {
    params.title = `inc_${searchFilter}`;
  }

  const { data, isLoading } = useFetch(
    ["dspContextualProducts", searchFilter, dspAdvertiser?.id],
    "/dsp/contextual_product_options",
    params,
    {
      select: (res) => {
        return (
          res.data?.targetOptions?.map((product) => {
            return {
              id: product.metadata.asin,
              asin: product.metadata.asin,
              name: product.metadata.title,
              ...product.metadata,
            };
          }) ?? []
        );
      },
      enabled: !!searchFilter,
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
